import { ArrowRight, Mail } from "lucide-react";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

export const BendGetStarted = () => {
  const [ref, vis] = useScrollReveal();

  return (
    <section
      id="get-started"
      data-testid="bend-get-started-section"
      className="bg-[#0F172A] py-28 md:py-40 lg:py-48 relative overflow-hidden"
    >
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[#0064E0] opacity-[0.04] blur-[120px] pointer-events-none" />

      <div ref={ref} className={`relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 reveal ${vis ? 'visible' : ''}`}>
        <div className="max-w-[680px] mx-auto text-center">
          <h2
            data-testid="bend-get-started-heading"
            className="font-['Playfair_Display'] font-semibold text-[clamp(24px,3vw,40px)] tracking-[-0.03em] text-white leading-[1.15]"
          >
            Ready to turn those {"\u201C"}one day{"\u201D"} ideas<br />into next week's action items?
          </h2>

          <div className="mt-10 md:mt-12">
            <p className="text-[17px] md:text-[18px] leading-[1.7] text-[#94A3B8]">
              Book a 30-minute call. We'll look at where your business is now
              and tell you straight where we'd start and whether we can help.
              If we're not the right fit, we'll say so. Either way you'll walk
              away knowing more than you came in with.
            </p>
          </div>

          <div className="mt-12 md:mt-16">
            <a
              href=""
              onClick={(e) => { e.preventDefault(); window.Calendly?.initPopupWidget({url: 'https://calendly.com/bldventuresgroup-marketing/30min'}); }}
              data-testid="bend-get-started-cta-button"
              className="calendly-cta btn-primary inline-flex items-center justify-center gap-3 bg-[#0064E0] text-white rounded-xl px-12 py-5 text-[18px] font-medium hover:bg-[#3B8EFF] focus:outline-none focus:ring-2 focus:ring-[#0064E0] focus:ring-offset-2 focus:ring-offset-[#0F172A] w-full sm:w-auto"
            >
              Book a Discovery Call
              <ArrowRight className="arrow-icon w-5 h-5" />
            </a>
          </div>

          <div className="mt-12 w-12 h-px bg-[#1E293B] mx-auto" />

          <div className="mt-8 flex items-center justify-center gap-2 text-[14px] text-[#64748B]">
            <Mail className="w-4 h-4 text-[#0064E0]" strokeWidth={1.5} />
            <span>
              Or email us directly:{" "}
              <a
                href="mailto:marketing@bldventuresgroup.com"
                data-testid="bend-contact-email-link"
                className="text-[#0064E0] hover:text-[#3B8EFF] underline underline-offset-4 decoration-[#0064E0]/30 hover:decoration-[#0064E0] transition-colors"
              >
                marketing@bldventuresgroup.com
              </a>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
